import { useState, useEffect } from "react";
import { Flex, Typography } from "antd";
import ExpenseFormType from "./components/ExpenseFormType";
import { ExpenseType } from "@/types/expenseType";
import ExpenseDraftForm from "./components/ExpenseDraftForm";
import ExpenseTabs from "./components/ExpenseTabs";
import { useGetExpenseTypes, useCreateExpensesBulk } from "./hooks/useExpenses";
import { registerExpenseLogoutHandler } from "@/utils/expenseLogoutHandler";
import { useAuth } from "@/context/AuthContext";
import { useGetExpenseDrafts } from "./hooks/useExpenseDrafts";

const RecordExpense = () => {
  const [expenseType, setExpenseType] = useState<ExpenseType>();
  const { user } = useAuth();
  const isWorker = user?.roles.includes("worker");

  const { data: expenseTypes, isFetching } = useGetExpenseTypes({
    config: {
      params: {
        include_inactive: false,
      },
    },
  });

  const { data: expenseDrafts } = useGetExpenseDrafts({
    config: {
      params: {
        limit: -1,
        sort: JSON.stringify([{ field: "created_at", order: "desc" }]),
        user_id_eq: user?.id,
      },
    },
  });

  // Get the hooks needed for the logout handler
  const { mutateAsync: submitDrafts } = useCreateExpensesBulk();

  // Register the logout handler when this page loads
  useEffect(() => {
    registerExpenseLogoutHandler({
      drafts: expenseDrafts || [],
      submitDrafts,
    });
  }, [expenseDrafts, submitDrafts]);

  return (
    <>
      <Typography.Title
        level={2}
        style={{ marginBottom: 24 }}
        hidden={isWorker}
      >
        Record Expense
      </Typography.Title>

      <Flex vertical={true} gap={24} style={{ maxWidth: "100%" }}>
        <ExpenseFormType
          expenseType={expenseType}
          expenseTypes={expenseTypes || []}
          isLoading={isFetching}
          setExpenseType={setExpenseType}
        />

        <ExpenseDraftForm expenseType={expenseType} />
        <ExpenseTabs expenseTypes={expenseTypes || []} />
      </Flex>
    </>
  );
};

export default RecordExpense;
